import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@/lib/firebase'
import { DEFAULT_CONTACT, withContactDefaults, type ContactSettings } from '@shared/contact'

/**
 * Föreningens kontaktuppgifter.
 *
 * Läses direkt ur det öppet läsbara dokumentet, utan inloggning – sidan som
 * behöver dem mest är integritetspolicyn, och den ska gå att läsa innan man
 * skapat ett konto.
 *
 * Går läsningen inte igenom svarar hooken med de inbyggda värdena i stället
 * för ingenting. En policy utan kontaktuppgift vore sämre än en med en
 * inaktuell, och det är just den sidan man öppnar när man vill klaga.
 */
export function useContact(): ContactSettings {
  const [contact, setContact] = useState<ContactSettings>(DEFAULT_CONTACT)

  useEffect(
    () =>
      onSnapshot(
        doc(db, 'settings', 'contact'),
        (snapshot) => setContact(withContactDefaults(snapshot.data())),
        () => setContact(DEFAULT_CONTACT),
      ),
    [],
  )

  return contact
}
